import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import Hero from "./Hero";
import TrustedProvenSolutions from "./TrustedProvenSol";
import TransformingIdeas from "./TransformingIdeas";
import OneStopSolutions from "./OneStopSolutions";
import CustomerCards from "../../Components/General/Cards/CustomerCards";
import NewlyLaunched from "./NewlyLaunched";
import { useLocation } from "react-router-dom";

const PremiumPrivateLabelQuery = "premium-private-labels";
function Marketplace() {
  const promotionRef = useRef(null);
  const oneStopRef = useRef(null);
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Handle scrolling to promotion section when premium-private-labels is in URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isPremiumPrivateLabel = searchParams.has(PremiumPrivateLabelQuery);

    if (isPremiumPrivateLabel && promotionRef.current && !loading) {
      promotionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [location.search, loading]);

  useEffect(() => {
    const productCategoriesUrl = "/marketplace/product-categories";
    // Scroll to the "OneStopSolutions" component when the user visits `/product-categories`
    if (location.pathname === productCategoriesUrl && oneStopRef.current) {
      oneStopRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.pathname]);

  return (
    <>
      <Hero />
      <TrustedProvenSolutions />
      <TransformingIdeas />
      <div ref={oneStopRef}>
        <OneStopSolutions setLoading={setLoading} />
      </div>
      <NewlyLaunched ref={promotionRef} />
      <CustomerCards />
    </>
  );
}

export default Marketplace;
